import { render } from "./SkinMaintenance.vue?vue&type=template&id=3d16f715&scoped=true&ts=true"
import script from "./SkinMaintenance.vue?vue&type=script&lang=ts"
export * from "./SkinMaintenance.vue?vue&type=script&lang=ts"

import "./SkinMaintenance.vue?vue&type=style&index=0&id=3d16f715&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d16f715"]])

export default __exports__